var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.20508 5.1932L6.02326 10.0114L15.0574 0.977295","stroke":"#444444","stroke-width":"2"}}),_c('rect',{attrs:{"y":"13.0227","width":"15.6591","height":"2","fill":"#444444"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }